/**
 * Returns whether or not the current environment is a server (Node.js) or a client (browser).
 *
 * This logic is extracted into a separate function for purposes of mocking server environments in
 * tests.
 */
export const isServer = () => typeof window === 'undefined';
